<template>
  <v-col cols="12" md="7">
    <v-row align="center" justify="center" class="flex-nowrap flex-row mr-6 mb-0">
      <v-btn
        v-for="(link, index) in otherLinks"
        :key="index"
        target="_blank"
        :icon="!link.text"
        :text="!!link.text"
        :href="link.href"
        :color="link.color || '#FFFFFF'"
        class="ml-2"
        style="width: auto; max-width: 110px;"
      >
        <img
          v-if="link.src"
          :src="link.src"
          class="mr-1"
          style="width: 21px; height: 21px;"
        />
        <span v-if="link.text" class="text-white text-caption font-weight-bold">
          {{ $t(link.text) }}
        </span>
      </v-btn>
    </v-row>
  </v-col>
</template>

<script>
export default {
    name: 'OtherLinksSection',
    props: {
        otherLinks: {
            type: Array,
            default: () => [],
            validator: (links) => {
                return links.every(link =>
                    typeof link === 'object' &&
                    link.href
                );
            }
        }
    }
};
</script>